import { ValueOrFunction, anyReallyAny } from "@cervval.js/common/src/tools/object.tools";

/** Uid of available drag and drop events */
export type DragAndDropEventUid = "dragstart" | "dragover" | "dragend" | "drop" | "dragabort";

/** Direction of the drag, either 'up', 'down' or null (if mouse is moving horizontally and not vertically). */
export type DragAndDropVerticalDirection = "up" | "down" | null;

/** Direction of the drag, either 'left', 'right' or null (if mouse is moving vertically and not horizontally). */
export type DragAndDropHorizontalDirection = "left" | "right" | null;

/** Point of drag and drop */
export type DragAndDropPoint = { x: number, y: number };

/**
 * Direction of pointer from drag start point
 */
export type PointerDirection = -1 | 0 | 1;

/** Keeps track of the direction in which the user is dragging along each axis. */
export type PointerDirectionDelta = { x: PointerDirection, y: PointerDirection };

/** Config of drag ref */
export type DragRefConfig<ItemData = anyReallyAny> = Partial<{
    /** if disabled, drag and drop on element will have no effect */
    disabled: ValueOrFunction<boolean>,

    /** ZIndex of dragPreview */
    zIndex: number,

    /** Class to be added to the preview element. */
    previewClass?: string | string[],

    /** Placeholder element */
    placeholder: (data: ItemData) => HTMLElement | "global",

    /** 
     * Allowed directions of drag and drop move 
     * Use it to allow moving elements in only one single direction
     * If undefined, direction allowed is XY
     */
    allowedDirections?: "x" | "y"
}>

//#region css variables

/** If attribute is defined, element is a cjs drop container */
export const CJS_DROP_CONTAINER_ATTR = "data-cjs-drop-container";

/** If attribute is defined, element is a cjs drop item */
export const CJS_DRAGGABLE_ITEM_ATTR = "data-cjs-draggable-item";